import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import { useState } from "react";
import useExportDocxFile from "../../request-vehicle/TemplateDocx/useExportDocxFile";
import useExportExcel from "../../../../../hook/use-export-excel";
import { get } from "lodash";
import moment from "moment";
import { useCheckbox } from "../../../../../hook/use-check-box";
import { TableHelpers } from "../../../../../helper/TableHelper";
import { DateFormat, requestStatus } from "../../../../../constants";
import { useCloneSecurityControlMutation } from "./use-clone-security-control-card";
import { Modal } from "antd";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';

export const useSercurityControlCardColumn = () => {
  const [currentItem, setCurrentItem] = useState<any>();
  const exportExcel = useExportExcel();
  const { cloneRequest } = useCloneSecurityControlMutation();

  const { exportForm } = useExportDocxFile({ item: currentItem, docType: 4 });
  const [isShortTermSelect, setIsShortTermSelect] = useState<boolean | null>(null);
  const requestCheckbox = useCheckbox<any, string>((item: any) => item.id);

  const handleSubmit = (item: any) => {
    exportForm(item);
  };

  const checkShortTerm = (item: any) => {
    const eStage = get(item, "eStage", "shortTerm");
    const isShortTerm = eStage === "shortTerm";
    return isShortTerm;
  };

  const handleCopy = async (item: any) => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/Chị vui lòng xác nhận trước khi tạo lại phiếu",
      okText: "Xác nhận",
      cancelText: "Huỷ",
      onOk() {
        cloneRequest(item);
      },
    });
  };

  const handleExportExcel = async (item: any) => {
    const isShortTerm = checkShortTerm(item);
    const date = moment().format("DD_MM_YYYY");

    await exportExcel({
      fileName: isShortTerm ? `DSNV_KSAN_NGANHAN_${date}` : `DSNV_KSAN_DAIHAN_${date}`,
      template: isShortTerm ? "security-control-card-short-term" : "security-control-card-long-term",
      data: item,
    });
  };

  const handleRequestExportClick = async () => {
    await exportExcel({
      fileName: isShortTermSelect ? "SecurityControlCardShortTermList" : "SecurityControlCardLongTermList",
      template: isShortTermSelect ? "security-control-card-short-term" : "security-control-card-long-term",
      data: Object.values(requestCheckbox.items),
    });
  };

  const renderStage = (stage: string) => {
    return stage === "longTerm" ? "Dài hạn" : "Ngắn hạn";
  };

  const renderSuggestion = (stage: string, suggestion: string) => {
    if (stage === "shortTerm") return suggestion === "provide" ? "Cấp thẻ" : "Cấp lại thẻ";
    return suggestion === "provide" ? "Cấp mới" : suggestion === "evict" ? "Gia hạn" : "Cấp lại";
  };

  const handleCheckboxClick = (item: any) => {
    /**
     * get first checked
     */
    if (requestCheckbox.length === 0) {
      const isShortTerm = checkShortTerm(item);

      setIsShortTermSelect(isShortTerm);
    }

    const after = requestCheckbox.toggle(item);

    if (after.length === 0) {
      setIsShortTermSelect(null);
    }
  };

  const columns: ColumnsType<any> = [
    {
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: 120,
      render: (_, record: any) => (
        <Button
          title={"Tạo lại phiếu"}
          className=""
          variant="outline-info"
          onClick={(e: any) => {
            e.stopPropagation();
            handleCopy(record);
          }}
        >
          <FontFa name="faCopy" size={"lg"} />
        </Button>
      ),
    },
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "80px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "120px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),
    },
    {
      title: "Giai đoạn thẻ KSAN",
      dataIndex: "eStage",
      key: "eStage",
      width: "180px",
      render: (text: string) => (
        <span className={text === "longTerm" ? "flag success" : "flag danger"}>{renderStage(text)}</span>
      ),
      filters: [
        { text: "Dài hạn", value: "longTerm" },
        { text: "Ngắn hạn", value: "shortTerm" },
      ],
      onFilter: (status: any, record) => record.eStage.indexOf(status) === 0,
    },
    {
      title: "Yêu cầu",
      dataIndex: "eSuggestion",
      key: "eSuggestion",
      width: "120px",
      render: (text: string, record: any) => (
        <span
          className={
            record.eSuggestion === "provide"
              ? "flag success"
              : record.eSuggestion === "evict"
              ? "flag warning"
              : "flag danger"
          }
        >
          {renderSuggestion(record.eStage, record.eSuggestion)}
        </span>
      ),
      filters: [
        { text: "Cấp thẻ", value: "provide" },
        { text: "Cấp lại thẻ", value: "renew" },
      ],
      onFilter: (status: any, record) => record.eSuggestion.indexOf(status) === 0,
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      width: "120px",
      render: (text: string) => <ApprovalStatus status={text} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed,
        },
        {
          text: "Đã bị từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (status: any, record) => record.eRequestStatus.indexOf(status) === 0,
    },
    {
      title: "Ngày cấp",
      dataIndex: "eAssigneeStatusDate",
      key: "eAssigneeStatusDate",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "120px",
      ...TableHelpers.searchRangePicker({ dataIndex: "eAssigneeStatusDate" }),
    },
    {
      title: "Ngày đến hạn",
      dataIndex: "eAssigneeStatusDate",
      key: "createdDateTime",
      render: (_, record: any) => {
        var content = record.eContent ? JSON.parse(record.eContent) : null;
        if (!content || !content[0]?.expiredDate) return "";
        dayjs.extend(customParseFormat);
        const date = dayjs(content[0]?.expiredDate, 'D/M/YYYY');

        return date.format(DateFormat.DD_MM_YYY);
      },
      align: "center" as const,
      width: "150px",
    },
    {
      title: "Ghi chú",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (_, record: any) => {
        const content = record.eContent ? JSON.parse(record.eContent) : null;
        if (content == null || !content[0]?.expiredDate) return "";

        const expiredDate = moment(content[0].expiredDate);
        const maxDate = moment().add(record.eStage === "shortTerm" ? 8 : 10, "days");

        var isExpired = expiredDate.isBefore(maxDate, "day");

        if (isExpired && record.isAutoRenew) return <span style={{ color: "red" }}>Tự động gia hạn</span>;
        if (isExpired) return <span style={{ color: "red" }}>Sắp hết hạn</span>;
        return "";
      },
      align: "center" as const,
      width: "150px",
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <>
          <Button
            title={"Xuất file"}
            className=""
            variant="outline-info"
            onClick={(e: any) => {
              e.stopPropagation();
              setCurrentItem(record);
              handleSubmit(record);
            }}
          >
            <FontFa name="faFileWord" size={"lg"} />
          </Button>
          <Button
            title={"Xuất excel"}
            className="ml-2"
            variant="outline-success"
            onClick={(e: any) => {
              e.stopPropagation();
              handleExportExcel(record);
            }}
          >
            <FontFa name="faFileExcel" size={"lg"} />
          </Button>
        </>
      ),
    },
  ];
  return { columns, isShortTermSelect, handleRequestExportClick, checkShortTerm, requestCheckbox, handleCheckboxClick };
};
